import Vue from 'vue'
import VueRouter from 'vue-router'
import Overview from '@/views/Overview'
import States from '@/views/States'
import Appendix from '@/views/Appendix'
import OverviewOld from '@/views/OverviewOld'
import Categories from '@/views/Categories'
import CategoriesIndex from '@/views/Categories/Index'
import Category from '@/views/Categories/Category'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Overview',
    component: Overview
  },
  {
    path: '/states',
    name: 'States',
    component: States
  },
  {
    path: '/categories',
    component: Categories,
    children: [
      { path: '', component: CategoriesIndex, name: 'Categories' },
      { path: ':catId', component: Category, name: 'Category', props: true }
    ]
  },
  {
    path: '/appendix',
    name: 'Appendix',
    component: Appendix
  },
  {
    path: '/overview-old',
    name: 'OverviewOld',
    component: OverviewOld
  },
  {
    path: '/*', redirect: { name: 'Overview' }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
